import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '@/components/common/Select/Select';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import { FormGroupProps } from './types';
import { VideoContentType } from '@/data/models/videoContentType';
import { IOptions } from '@/data/models/option';

type Props = FormGroupProps & {
  handleVideoContentType: (value: IOptions<VideoContentType> | null) => void;
};

export default function VideoContentTypeFormGroup({
  album,
  readonly,
  disabled,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleVideoContentType,
}: Props) {
  const { t } = useTranslation();
  const videoContentTypeOptions: IOptions<VideoContentType>[] = [
    {
      label: t('product.videoContentType.Music'),
      value: VideoContentType.Music,
    },
    {
      label: t('product.videoContentType.NonMusic'),
      value: VideoContentType.NonMusic,
    },
  ];
  const selectedVideoContentType = album.albumMetaData?.videoContentType;

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.videoContentType"
      hasErrors={fieldHasErrors('VideoContentType')}
    >
      <Select
        id="videoContentTypeTypeahead"
        labelTitle={t('product.editProduct.videoContentType')}
        labelClass="col-sm-3 form-label"
        isClearable={!readonly}
        placeholder=""
        onChange={(e: any) => {
          handleVideoContentType(e);
        }}
        initialOption={videoContentTypeOptions.find(
          (vct) => vct.value === selectedVideoContentType
        )}
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('VideoContentType')}
        errorMessage={findErrorMessage('VideoContentType')}
        isRequired={true}
        showValidationErrors={showValidationErrors}
        fieldValidationKey={'productEditMode.VideoContentType'}
        baseOptions={videoContentTypeOptions}
      ></Select>
    </FormGroupWithTooltip>
  );
}
